import React from 'react';
import { useOptionConfigurator } from '../OptionConfiguratorContext';
import { Trans } from '@lingui/react/macro';
import theme from './HomePage.module.scss';
import { DeadlineList } from './DeadlineList';
import { OverviewSignAndSend } from './OverviewSignAndSend';
import { Card, NoItemsCard } from '@ygtechnologies/rubus-ui';

export const OptionConfiguratorHomePage: React.FC = () => {
    const { projectData } = useOptionConfigurator();
    const deadlines = projectData?.deadlines || [];
    const deadlinesWithOptions = deadlines.filter((d) => d.hasOptionsAttached);

    return (
        <Card className={theme.homePageCard}>
            <div className={theme.overviewHeader}>
                <div className={theme.roomOverviewSection}>
                    <h2>
                        <Trans>Deadline overview</Trans>
                    </h2>
                    <Trans>
                        The room overview helps you keep track of important decision dates for each room. Deadlines are
                        shown by room, the deadline date, and a shortcut that takes you directly to that room.
                    </Trans>
                </div>
                <OverviewSignAndSend />
            </div>
            <div className={theme.deadlineList}>
                {deadlinesWithOptions.length === 0 ? (
                    <NoItemsCard title={<Trans>No options available</Trans>} />
                ) : (
                    <DeadlineList deadlines={deadlines} />
                )}
            </div>
        </Card>
    );
};
